import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const PublicFooter = () => {
  const { t, language } = useLanguage();
  
  // Helper function to get legal document route URL
  const getLegalDocumentUrl = (type) => {
    return `/legal/${type}`;
  };
  
  // Parse footerCopyright to replace "ZeuZ IT" with a link
  const renderCopyright = () => {
    const copyrightText = t.footerCopyright;
    const parts = copyrightText.split('ZeuZ IT');
    
    if (parts.length === 2) {
      return (
        <>
          {parts[0]}
          <a 
            href="https://zeuz-it.de/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-semibold text-cyan-600 dark:text-cyan-400 hover:text-cyan-700 dark:hover:text-cyan-300 transition-colors"
          >
            ZeuZ IT
          </a>
          {parts[1]}
        </>
      );
    }
    // Fallback if format doesn't match - return text as is
    return copyrightText;
  };
  
  return (
    <footer className="bg-white dark:bg-gray-900 border-t dark:border-gray-800 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
            {renderCopyright()}
          </p>
          <span className="hidden md:inline text-gray-400">|</span>
          <a 
            href={getLegalDocumentUrl('privacy')} 
            className="text-sm text-gray-500 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
          >
            {t.privacyPolicy}
          </a>
          <span className="hidden md:inline text-gray-400">|</span>
          <a 
            href={getLegalDocumentUrl('terms')} 
            className="text-sm text-gray-500 dark:text-gray-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors"
          >
            {t.legalNotice}
          </a>
        </div>
      </div>
    </footer>
  );
};